export const bindStoresListActions = (el) => {
    const storeEls = el.querySelectorAll('.currys-store');

    storeEls.forEach((storeEl) => {
        const toggleDetails = storeEl.querySelector('[data-toggle-store-details]');

        toggleDetails.addEventListener('click', () => {
            const toggleState = storeEl.dataset.isToggled;
            storeEl.dataset.isToggled = toggleState === 'true' ? 'false' : 'true';
        });
    });
};
